import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const SubcategoryPage = lazy(() => import('../pages/services/subcategory/page'));
const ProductDetailPage = lazy(() => import('../pages/services/product/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const ShopPage = lazy(() => import('../pages/shop/page'));
const ShopProductDetailPage = lazy(() => import('../pages/shop/product/page'));
const AdminPage = lazy(() => import('../pages/admin/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const CondicionesPage = lazy(() => import('../pages/condiciones-de-contratacion/page'));
const FormasPagoPage = lazy(() => import('../pages/formas-de-pago/page'));
const PoliticaCookiesPage = lazy(() => import('../pages/politica-de-cookies/page'));
const PoliticaPrivacidadPage = lazy(() => import('../pages/politica-de-privacidad/page'));
const AvisoLegalPage = lazy(() => import('../pages/aviso-legal/page'));
const MiCuentaPage = lazy(() => import('../pages/mi-cuenta/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/services/:subcategorySlug',
    element: <SubcategoryPage />,
  },
  {
    path: '/services/:subcategorySlug/:productSlug',
    element: <ProductDetailPage />,
  },
  {
    path: '/shop',
    element: <ShopPage />,
  },
  {
    path: '/shop/:productSlug',
    element: <ShopProductDetailPage />,
  },
  {
    path: '/admin',
    element: <AdminPage />,
  },
  {
    path: '/condiciones-de-contratacion',
    element: <CondicionesPage />,
  },
  {
    path: '/formas-de-pago',
    element: <FormasPagoPage />,
  },
  {
    path: '/politica-de-cookies',
    element: <PoliticaCookiesPage />,
  },
  {
    path: '/politica-de-privacidad',
    element: <PoliticaPrivacidadPage />,
  },
  {
    path: '/aviso-legal',
    element: <AvisoLegalPage />,
  },
  {
    path: '/mi-cuenta',
    element: <MiCuentaPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
